"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MaritalStatusTypes = void 0;
var MaritalStatusTypes;
(function (MaritalStatusTypes) {
    MaritalStatusTypes["MARRIED"] = "married";
    MaritalStatusTypes["SINGLE"] = "single";
    MaritalStatusTypes["OTHER"] = "other";
    MaritalStatusTypes["DIVORCED"] = "divorced";
    MaritalStatusTypes["SEPARATED"] = "separated";
    MaritalStatusTypes["CIVIL_UNION"] = "civil union";
    MaritalStatusTypes["DOMESTIC_PARTNERSHIP"] = "domestic partnership";
    MaritalStatusTypes["WIDOWED"] = "widowed";
})(MaritalStatusTypes = exports.MaritalStatusTypes || (exports.MaritalStatusTypes = {}));
